import { createRouter, createWebHashHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import chatView from '../views/chatView.vue'

const routes = [
  {
    path: '/',
    name: 'root',
    component: chatView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "HomeView" */ '../views/HomeView.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "AboutView" */ '../views/AboutView.vue')
  },
  {
    path: '/users',
    name: 'users',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "UsersView" */ '../views/UsersView.vue')
  },
  {
    path: '/clients',
    name: 'clients',
    component: () => import(/* webpackChunkName: "ClientsView" */ '../views/ClientsView.vue')
  },
  {
    path: '/chat',
    name: 'chat',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "chatView" */ '../views/chatView.vue')
    component: chatView
  },
  {
    path: '/rag',
    name: 'rag',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "RAGView" */ '../views/RAGView.vue')
  },
  {
    path: '/messages',
    name: 'messages',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "MessagesView" */ '../views/MessagesView.vue')
  },
  {
    path: '/usermessages',
    name: 'usermessages',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "userMessages" */ '../views/userMessagesView.vue')
  },
  {
    path: '/login/:key?',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "LoginView" */ '../views/LoginView.vue')
  },
  {
    path: '/register',
    name: 'register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "RegisterView" */ '../views/RegisterView.vue')
  },
  {
    path: '/restore',
    name: 'restore',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "RestoreView" */ '../views/RestoreView.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "SettingsView" */ '../views/SettingsView.vue')
  },
  {
    path: '/success',
    name: 'success',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "SuccsessPaymentView" */ '../views/SuccsessPaymentView.vue')
  },
  {
    path: '/stats',
    name: 'stats',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "StatsView" */ '../views/StatsView.vue')
  },
  {
    path: '/sysstats',
    name: 'sysstats',
    component: () => import(/* webpackChunkName: "sysStatsView" */ '../views/SysStatsView.vue')
  },
  {
    path: '/admin-settings',
    name: 'admin-settings',
    component: () => import(/* webpackChunkName: "adminSettingsView" */ '../views/AdminSettingsView.vue')
  },
  {
    path: '/userdb',
    name: 'userdb',
    component: () => import(/* webpackChunkName: "UserdbView" */ '../views/UserdbView.vue')
  },
  {
    path: '/todo',
    name: 'todo',
    component: () => import(/* webpackChunkName: "UserdbView" */ '../views/ToDoView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/restore', '/success']
  const pathStart = to.path.split('/').length > 1 ? '/' + to.path.split('/')[1] : to.path
  const authRequired = !publicPages.includes(pathStart)
  const loggedIn = localStorage.getItem('accessKey')

  if (authRequired && !loggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router
